<template>
    <ModalComponent
        :name="'anular-' + base.id"
        :title="'Anular deportista: ' + base.nombre"
        v-on:close="() => close(false)"
    >
        <ContentOrLoading>
            <div class="row" v-if="!loading">
                <div class="col-12 mb-2 text-center">
                    <h5>¿Está segur@ de anular este deportista?</h5>
                </div>
                <div class="col-12 text-center">
                    <h4 v-if="base.tiene_plazos">Este deportista se ha inscrito mediante plazos, seleccione si quiere anular el deportista devolviendo el/los plazo/s pagados o sin devolverlos</h4>
                    <div>
                        <Button :disabled="disableButton" type="button" class="col-md-4" name="button" @click="anularBase()">Anular sin devolver el dinero</Button>
                        <Button :disabled="disableButton" id="anular" class="mx-2 col-md-4" type="button" name="button" @click="anularBase(true)">Anular sin GG</Button>
                    </div>
                    <div class="mt-4">
                        <Button :disabled="disableButton" v-if="!anular_con_gd" id="anular" class="mx-2 col-md-3" type="button" name="button" @click="anularConGD()">Anular con GG</Button>
                        <OcultarConPassword v-if="anular_con_gd" message="Para anular al deportista con gastos de gestión tienes que poner una contraseña:">
                            <Button :disabled="disableButton" id="anular" class="mr-2 my-2 col-md-4" type="button" name="button" @click="anularBase(true, 1)">Anular</Button>                    
                        </OcultarConPassword> 
                    </div>
                </div>
            </div>
        </ContentOrLoading>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import OcultarConPassword from "@/components/backend/components/OcultarConPassword.vue";

    export default {
        props: ['base'],
        data() {
            return {
                disableButton: false,
                loading: false,
                anular_con_gd: false
            }
        },
        methods: {
            anularBase(devolver_dinero = false, con_gd = 0) {
                const params = {
                    filters: {
                        con_gd: con_gd,
                        devolver_dinero: devolver_dinero
                    },
                    base_id: this.base.id,
                    lista_id: this.lista_id
                };

                this.loading = true;
                this.disableButton = true;

                this.$store.dispatch(this.config.getVuexAlias('back.bases.anular'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.$emit('actualizado');
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                    this.disableButton = false;
                }).finally(() => {
                    this.loading = false;
                    this.close();
                });

            },
            close() {
                this.disableButton = false;
                this.loading = false;
                this.anular_con_gd = false;
                this.$emit('close', 'anular-' + this.base.id);
            },
            anularConGD() {
                this.anular_con_gd = true;
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        components: { ModalComponent, OcultarConPassword }
    }
</script>